import { useNavigate } from 'react-router-dom';
import PagesLinksData from "../../../data/PagesLinksData.json"
import ServiceDropdownList from "./ServiceDropdownList"
import "../navbar.css"
import { useTranslation } from 'react-i18next';
import { useLangUrl } from '../../../utilities/useLangUrl';

export default function NavPages({ isNavOpen }) {

    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const langUrl = useLangUrl();

    return (
        <div className="d-flex flex-column flex-md-row align-items-center position-relative">
            {PagesLinksData.map((page, index) => (
                <div
                    key={index}
                    onClick={() => {
                        isNavOpen ? navigate(`${langUrl}/${page.pageLink}`) : (page.pageNameEn !== "Our Services" && navigate(`${langUrl}/${page.pageLink}`)) // Navigate to the link
                    }}
                    className={`header-nav nav-link text-center ${page.addClass}`}>
                    {i18n.language === "ar" ? page.pageName : page.pageNameEn}
                    <ServiceDropdownList />
                </div>
            ))}
        </div>
    );
}

